export default async function i18nLoader(locale = 'en', namespace = 'common'){
  try {
    const translationsJSON = await import(`../locales/${locale}/${namespace}.json`)

    return translationsJSON.default
  }
  catch (error) {
    console.error(error)
    
    return {}
  }
}
